import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../../pages/Languages/LanguageContext";
import "./sidebar.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const { t } = useContext(LanguageContext);
  const role = useSelector((state) => state.auth?.user?.role);

  return (
    <div
      className="sidebar shadow-lg d-flex flex-column  position-fixed   "
      style={{
        height: "95vh",
        marginTop: "14px",
      }}
    >
      <Link to="/dashboard" className="navbar-brand">
        <div className="text-light text-center mb-2 fs-5 fw-bold">
          Fetan Delivery
        </div>
      </Link>
      <ul className="list-group rounded-0 mt-3 ">
        {role && role !== "partner" && (
          <li className="  list-group-item list-hover sidebar-item ">
            <NavLink to="/dashboard" className="list-sub-hover ">
              <i
                className="bi bi-speedometer2 text-light list-hover-icon sidebar-icon"
                style={{ fontSize: "14px" }}
              ></i>

              <span className="list-hover-text " style={{ fontSize: "14px" }}>
                {t.dashboard}{" "}
              </span>
            </NavLink>
          </li>
        )}
        {role && role !== "partner" && (
          <li className="  list-group-item list-hover sidebar-item ">
            <NavLink to="/delivery-request" className="list-sub-hover ">
              <i
                className=" text-light bi bi-send list-hover-icon sidebar-icon"
                style={{ fontSize: "14px" }}
              ></i>

              <span className="list-hover-text  " style={{ fontSize: "14px" }}>
                {t.deliveryrequest}{" "}
              </span>
            </NavLink>
          </li>
        )}
        <li className="  list-group-item list-hover sidebar-item">
          <NavLink to="/my-deliveries" className="list-sub-hover">
            <i
              className="bi text-light bi-window-sidebar   list-hover-icon sidebar-icon"
              style={{ fontSize: "14px" }}
            ></i>
            <span className="list-hover-text  " style={{ fontSize: "14px" }}>
              {t.mydeliveries}
            </span>
          </NavLink>
        </li>
        {role && role !== "partner" && (
          <li className="list-group-item list-hover sidebar-item">
            <NavLink to="/delivery-person" className="list-sub-hover">
              <i
                className="bi text-light list-hover-icon  bi-truck sidebar-icon"
                style={{ fontSize: "14px" }}
              ></i>
              <span className="list-hover-text " style={{ fontSize: "14px" }}>
                {t.deliveryperson}{" "}
              </span>
            </NavLink>
          </li>
        )}

        <li className="list-group-item list-hover sidebar-item">
          <NavLink to="/profile" className="list-sub-hover">
            <i
              className="bi text-light list-hover-icon   bi-person sidebar-icon"
              style={{ fontSize: "14px" }}
            ></i>
            <span className="list-hover-text " style={{ fontSize: "14px" }}>
              {t.profile}{" "}
            </span>
          </NavLink>
        </li>

        {role && role !== "partner" && (
          <li className="list-group-item list-hover sidebar-item">
            <NavLink to="/delivery-settings" className="list-sub-hover">
              <i
                className="bi text-light list-hover-icon  bi-gear sidebar-icon"
                style={{ fontSize: "14px" }}
              ></i>
              <span className="list-hover-text " style={{ fontSize: "14px" }}>
                {t.deliverySettings}
              </span>
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
